import {
  Alert,
  Box,
  Button,
  CardMedia,
  CircularProgress,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import Modal from "@mui/material/Modal";

const URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3002"
    : "";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  maxWidth: "90vw",
  borderRadius: "16px",
  background: "rgba(0,0,0,0.95)",
  border: "1px solid rgba(255,255,255,0.2)",
  boxShadow: "0 0 25px rgba(0,0,0,0.8)",
  p: 4,
};

export const Market = () => {
  const { informacion } = useSelector((state) => state.userSlice);

  const [open, setOpen] = useState(false);
  const [input, setInput] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);

  const [items, setItems] = useState([]);
  const [loadingItems, setLoadingItems] = useState(true);
  const [buying, setBuying] = useState(false);

  // Saldos locales para actualizar de inmediato en el mercado.
  // dinero     = HUESO in-game
  // dineroReal = HUESO balance
  // fusion     = VIPHUESO balance
  const [saldos, setSaldos] = useState({
    dinero: 0,
    dineroReal: 0,
    fusion: 0,
  });

  const [snack, setSnack] = useState({
    open: false,
    type: "success",
    msg: "",
  });

  const username = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("user"));
    } catch {
      return null;
    }
  }, []);

  const token = useMemo(() => {
    return (
      username?.token ||
      username?.accessToken ||
      username?.jwt ||
      sessionStorage.getItem("token") ||
      ""
    );
  }, [username]);

  const nombreUsuario =
    informacion?.nombre || informacion?.user || username?.user || "";

  useEffect(() => {
    setSaldos({
      dinero: Number(informacion?.dinero || 0),
      dineroReal: Number(informacion?.dineroReal || 0),
      fusion: Number(informacion?.fusion || 0),
    });
  }, [informacion]);

  const showMsg = (msg, type = "success") => {
    setSnack({
      open: true,
      type,
      msg,
    });
  };

  const getCookie = (name) => {
    try {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        return parts.pop().split(";").shift();
      }
      return "";
    } catch {
      return "";
    }
  };

  const obtenerToken = () => {
    try {
      const userSession = JSON.parse(sessionStorage.getItem("user") || "{}");
      const userLocal = JSON.parse(localStorage.getItem("user") || "{}");

      return (
        token ||
        userSession?.token ||
        userSession?.accessToken ||
        userSession?.jwt ||
        userSession?.data?.token ||
        userSession?.usuario?.token ||
        userLocal?.token ||
        userLocal?.accessToken ||
        userLocal?.jwt ||
        userLocal?.data?.token ||
        userLocal?.usuario?.token ||
        sessionStorage.getItem("token") ||
        localStorage.getItem("token") ||
        getCookie("token") ||
        ""
      );
    } catch {
      return (
        sessionStorage.getItem("token") ||
        localStorage.getItem("token") ||
        getCookie("token") ||
        ""
      );
    }
  };

 const authHeaders = () => {
  const realToken = obtenerToken();

  return {
    "Content-Type": "application/json",
    ...(realToken
      ? {
          token: realToken,
        }
      : {}),
  };
};

  const leerJsonSeguro = async (response) => {
    const contentType = response.headers.get("content-type") || "";

    if (!contentType.includes("application/json")) {
      const text = await response.text();
      console.log("Respuesta NO JSON:", text);

      throw new Error(
        "La API respondió HTML en vez de JSON. Revisa la ruta del backend."
      );
    }

    return response.json();
  };

  const normalizarNumero = (valor) => {
    const numero = Number(valor || 0);
    if (!Number.isFinite(numero)) return 0;
    return numero;
  };

  const formatearNumero = (valor) => {
    return Number(valor || 0).toLocaleString();
  };

  const getPrecioExterno = (item) => {
    if (!item) return 0;

    if (item.monedaExterna === "HUESO") {
      return normalizarNumero(item.precioHueso);
    }

    if (item.monedaExterna === "VIPHUESO") {
      return normalizarNumero(item.precioVipHueso);
    }

    if (item.monedaExterna === "SWAP.HIVE") {
      return normalizarNumero(item.precioSwapHive);
    }

    return 0;
  };

  const getNombreVisible = (item) => {
    if (!item) return "";

    if (item.slug === "inicial") return "Initial Land";
    if (item.slug === "lvl") return "LVL UP";

    return item.nombre;
  };

  // DINERO = HUESO in-game. Solo aplica para items que normalmente cuestan HUESO.
  const puedeComprarConDineroJuego = (item) => {
    return (
      item?.monedaExterna === "HUESO" &&
      item?.bloqueadoConDinero !== true &&
      item?.slug !== "inicial" &&
      Number(item?.precioFinalDinero || 0) > 0
    );
  };

  // Saldo interno de token:
  // HUESO BALANCE    => usuario.dineroReal
  // VIPHUESO BALANCE => usuario.fusion
  const puedeComprarConSaldoToken = (item) => {
    return (
      item &&
      item.slug !== "inicial" &&
      ["HUESO", "VIPHUESO"].includes(item.monedaExterna)
    );
  };

  const getTextoPagoExterno = (item) => {
    if (!item) return "";

    if (item.slug === "inicial") {
      return "SWAP.HIVE payment";
    }

    return `${item.monedaExterna} payment`;
  };

  const getTextoBotonExterno = (item) => {
    if (!item) return "BUY";

    if (item.slug === "inicial") {
      return "BUY WITH SWAP.HIVE";
    }

    return `BUY WITH ${item.monedaExterna} WALLET HIVE`;
  };

  const getTextoSaldoToken = (item) => {
    if (!item) return "";

    if (item.monedaExterna === "HUESO") {
      return "HUESO IN-GAME";
    }

    if (item.monedaExterna === "VIPHUESO") {
      return "VIPHUESO BALANCE GAME";
    }

    return "";
  };

  const getCampoSaldoToken = (item) => {
    if (!item) return null;

    if (item.monedaExterna === "HUESO") return "dineroReal";
    if (item.monedaExterna === "VIPHUESO") return "fusion";

    return null;
  };

  const cargarMercado = async () => {
    try {
      setLoadingItems(true);

      const response = await fetch(
        `${URL}/api/mercado/items/?nombre=${encodeURIComponent(nombreUsuario)}`,
        {
          method: "GET",
          headers: authHeaders(),
        }
      );

      const data = await leerJsonSeguro(response);
      console.log("Respuesta mercado:", data);

      if (!response.ok || !data?.ok) {
        throw new Error(data?.msg || data?.error || "No se pudo cargar el mercado.");
      }

      setItems(Array.isArray(data.items) ? data.items : []);
    } catch (error) {
      console.log("Error cargando mercado:", error);
      showMsg(error?.message || "Error cargando mercado.", "error");
    } finally {
      setLoadingItems(false);
    }
  };

  useEffect(() => {
    cargarMercado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nombreUsuario]);

  const handleOpen = (item) => {
    setSelectedItem(item);
    setInput(1);
    setOpen(true);
  };

  const handleClose = () => {
    if (buying) return;
    setOpen(false);
    setSelectedItem(null);
    setInput(1);
  };

  const selectedCantidad = Math.max(1, Number(input || 1));
  const precioExternoSeleccionado = getPrecioExterno(selectedItem);

  const totalExterno =
    selectedItem?.slug === "inicial"
      ? precioExternoSeleccionado
      : precioExternoSeleccionado * selectedCantidad;

  const totalDineroSeleccionado =
    selectedItem && puedeComprarConDineroJuego(selectedItem)
      ? Number(selectedItem.precioFinalDinero || 0) * selectedCantidad
      : 0;

  const totalSaldoTokenSeleccionado =
    selectedItem && puedeComprarConSaldoToken(selectedItem)
      ? precioExternoSeleccionado * selectedCantidad
      : 0;

  const tieneSaldoDinero = () => {
    return Number(saldos.dinero || 0) >= Number(totalDineroSeleccionado || 0);
  };

  const tieneSaldoToken = () => {
    const campo = getCampoSaldoToken(selectedItem);
    if (!campo) return false;

    return Number(saldos[campo] || 0) >= Number(totalSaldoTokenSeleccionado || 0);
  };

  const actualizarSaldosDesdeRespuesta = (data) => {
    if (!data || !data.ok) return;

    // Compra con usuario.dinero
    if (typeof data?.saldoDespues !== "undefined" && !data?.campoSaldo) {
      setSaldos((prev) => ({
        ...prev,
        dinero: Number(data.saldoDespues || 0),
      }));
      return;
    }

    // Compra con usuario.dineroReal o usuario.fusion
    if (data?.campoSaldo && typeof data?.saldoDespues !== "undefined") {
      setSaldos((prev) => ({
        ...prev,
        [data.campoSaldo]: Number(data.saldoDespues || 0),
      }));
    }
  };

  const handleBuyWithDinero = async () => {
    try {
      if (!selectedItem) return;

      const cantidad = Math.max(1, Number(input || 1));

      if (!Number.isFinite(cantidad) || cantidad < 1) {
        showMsg("Cantidad inválida.", "error");
        return;
      }

      if (!puedeComprarConDineroJuego(selectedItem)) {
        showMsg(
          "Mini-Hueso solo puede usarse para items que también se compran con HUESO.",
          "error"
        );
        return;
      }

      if (!tieneSaldoDinero()) {
        showMsg(
          `Saldo insuficiente. Necesitas ${formatearNumero(
            totalDineroSeleccionado
          )} Mini-Hueso y tienes ${formatearNumero(saldos.dinero)} Mini-Hueso.`,
          "error"
        );
        return;
      }

      setBuying(true);

      const response = await fetch(`${URL}/api/mercado/comprar-dinero/`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          itemId: selectedItem._id,
          slug: selectedItem.slug,
          cantidad,
          nombreUsuario,
        }),
      });

      const data = await leerJsonSeguro(response);

      if (response.status === 401 || response.status === 403) {
        throw new Error(
          data?.msg || data?.error || "Tu sesión expiró. Cierra sesión e inicia de nuevo."
        );
      }

      if (!response.ok || !data?.ok) {
        throw new Error(data?.msg || data?.error || "No se pudo realizar la compra.");
      }

      actualizarSaldosDesdeRespuesta(data);
      // ✅ Avisar al NavBar/perfil que debe actualizar saldos desde getInformacion
      window.dispatchEvent(new Event("actualizar-saldos"));


      showMsg(data?.msg || "Purchase completed successfully.", "success");
      handleClose();
      await cargarMercado();
    } catch (error) {
      console.log("Error comprando con Mini-Hueso:", error);
      showMsg(error?.message || "Error comprando con Mini-Hueso.", "error");
    } finally {
      setBuying(false);
    }
  };

  const handleBuyWithSaldoToken = async () => {
    try {
      if (!selectedItem) return;

      const cantidad = Math.max(1, Number(input || 1));

      if (!Number.isFinite(cantidad) || cantidad < 1) {
        showMsg("Cantidad inválida.", "error");
        return;
      }

      if (!puedeComprarConSaldoToken(selectedItem)) {
        showMsg("Este item no permite compra con saldo interno.", "error");
        return;
      }

      if (!tieneSaldoToken()) {
        const campo = getCampoSaldoToken(selectedItem);
        const saldoActual = Number(saldos[campo] || 0);

        showMsg(
          `Saldo insuficiente. Necesitas ${formatearNumero(
            totalSaldoTokenSeleccionado
          )} ${selectedItem.monedaExterna} y tienes ${formatearNumero(
            saldoActual
          )} ${selectedItem.monedaExterna}.`,
          "error"
        );
        return;
      }

      setBuying(true);

      const response = await fetch(`${URL}/api/mercado/comprar-saldo-token/`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          itemId: selectedItem._id,
          slug: selectedItem.slug,
          cantidad,
          nombreUsuario,
        }),
      });

      const data = await leerJsonSeguro(response);

      if (response.status === 401 || response.status === 403) {
        throw new Error(
          data?.msg || data?.error || "Tu sesión expiró. Cierra sesión e inicia de nuevo."
        );
      }

      if (!response.ok || !data?.ok) {
        throw new Error(data?.msg || data?.error || "No se pudo realizar la compra.");
      }

      actualizarSaldosDesdeRespuesta(data);

      // ✅ Avisar al NavBar/perfil que debe actualizar saldos desde getInformacion
         window.dispatchEvent(new Event("actualizar-saldos"));


      showMsg(data?.msg || "Compra realizada correctamente.", "success");
      handleClose();
      await cargarMercado();
    } catch (error) {
      console.log("Error comprando con saldo token:", error);
      showMsg(error?.message || "Error comprando con saldo token.", "error");
    } finally {
      setBuying(false);
    }
  };

  const handleBuyWithKeychain = () => {
    try {
      if (!selectedItem) return;

      if (!window.hive_keychain) {
        showMsg("Hive Keychain no está disponible.", "error");
        return;
      }

      const cantidadInput = Math.max(1, Number(input || 1));

      if (!Number.isFinite(cantidadInput) || cantidadInput < 1) {
        showMsg("Cantidad inválida.", "error");
        return;
      }

      const precioUnidad = getPrecioExterno(selectedItem);
      const moneda = selectedItem?.monedaExterna;

      if (!precioUnidad || precioUnidad <= 0 || !moneda) {
        showMsg("Este item no tiene precio externo válido.", "error");
        return;
      }

      const cantidadFinal =
        selectedItem.slug === "inicial"
          ? precioUnidad
          : precioUnidad * cantidadInput;

      const json = {
        contractName: "tokens",
        contractAction: "transfer",
        contractPayload: {
          symbol: moneda,
          to: "mv-deposito",
          quantity: cantidadFinal.toString(),
          memo: selectedItem.nombre,
        },
      };

      if (!username?.user) {
        showMsg("No se encontró el usuario en sesión.", "error");
        return;
      }

      setBuying(true);

      window.hive_keychain.requestCustomJson(
        username.user,
        "ssc-mainnet-hive",
        "Active",
        JSON.stringify(json),
        "Transfer",
        function (response) {
          console.log(response);
          setBuying(false);

          if (response?.success) {
            showMsg(
              "Transacción enviada. El item se entregará cuando el sistema confirme el pago.",
              "success"
            );
            handleClose();
          } else {
            showMsg(
              response?.message || "La transacción fue cancelada o falló.",
              "error"
            );
          }
        }
      );
    } catch (error) {
      console.log("Error comprando con Keychain:", error);
      setBuying(false);
      showMsg(error?.message || "Error comprando con Keychain.", "error");
    }
  };

  const cardStyle = {
    m: 3,
    width: { xs: "140px", md: "190px" },
    minHeight: "350px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "16px",
    background: "rgba(0,0,0,0.5)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow: "0 8px 20px rgba(0,0,0,0.6)",
    transition: "0.3s",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: "0 0 20px rgba(255,165,0,0.8)",
    },
    p: 2,
    zIndex: 1,
  };

  const buttonStyle = {
    width: "175px",
    mt: 1,
    background: "linear-gradient(45deg, #ff8c00, #ff3c00)",
    color: "#fff",
    fontWeight: "bold",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(255,140,0,0.7)",
    "&:hover": {
      background: "linear-gradient(45deg, #ff3c00, #ff8c00)",
      transform: "scale(1.03)",
    },
    "&:disabled": {
      background: "rgba(120,120,120,0.5)",
      color: "rgba(255,255,255,0.5)",
    },
  };

  const secondaryButtonStyle = {
    width: "175px",
    mt: 1,
    background: "linear-gradient(45deg, #1e88e5, #00bcd4)",
    color: "#fff",
    fontWeight: "bold",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(0,188,212,0.7)",
    "&:hover": {
      background: "linear-gradient(45deg, #00bcd4, #1e88e5)",
      transform: "scale(1.03)",
    },
    "&:disabled": {
      background: "rgba(120,120,120,0.5)",
      color: "rgba(255,255,255,0.5)",
    },
  };

  const balanceButtonStyle = {
    width: "175px",
    mt: 1,
    background: "linear-gradient(45deg, #7b1fa2, #e040fb)",
    color: "#fff",
    fontWeight: "bold",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(224,64,251,0.7)",
    "&:hover": {
      background: "linear-gradient(45deg, #e040fb, #7b1fa2)",
      transform: "scale(1.03)",
    },
    "&:disabled": {
      background: "rgba(120,120,120,0.5)",
      color: "rgba(255,255,255,0.5)",
    },
  };

  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(https://res.cloudinary.com/druu0mcam/image/upload/v1719339319/Diseño_sin_título_56_htku49_qnv3i1.png)`,
        backgroundSize: "cover",
        minHeight: { xs: "100vh", md: "91vh" },
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        alignItems: "center",
        p: 2,
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.6)",
          zIndex: 0,
        },
      }}
    >
      {loadingItems ? (
        <Box sx={{ zIndex: 1, textAlign: "center" }}>
          <CircularProgress />
          <Typography sx={{ color: "#fff", mt: 2 }}>
            Loading market...
          </Typography>
        </Box>
      ) : (
        items.map((item, i) => {
          const disabledInitial =
            item.slug === "inicial" && informacion?.packInicial === true;

          const precioExterno = getPrecioExterno(item);
          const puedeDinero = puedeComprarConDineroJuego(item);
          const puedeSaldoToken = puedeComprarConSaldoToken(item);

          return (
            <Box key={item._id || item.slug || i} sx={cardStyle}>
              <CardMedia
                component="img"
                sx={{
                  width: "100%",
                  height: "120px",
                  objectFit: "contain",
                  borderRadius: "12px",
                  mb: 1,
                  transition: "0.3s",
                  "&:hover": { transform: "scale(1.1)" },
                }}
                image={item.image}
              />

              <Typography
                sx={{
                  color: "#fff",
                  fontWeight: "bold",
                  textAlign: "center",
                  textShadow: "0 0 10px rgba(255,255,255,0.7)",
                }}
              >
                {getNombreVisible(item)}
              </Typography>

              {precioExterno > 0 && (
                <Typography
                  sx={{
                    color: "#FFD700",
                    fontWeight: "bold",
                    textShadow: "0 0 8px gold",
                    textAlign: "center",
                    fontSize: "0.85rem",
                  }}
                >
                  {formatearNumero(precioExterno)} {item.monedaExterna}
                </Typography>
              )}

              {puedeDinero && (
                <Typography
                  sx={{
                    color: "#00e5ff",
                    fontWeight: "bold",
                    textShadow: "0 0 8px #00e5ff",
                    textAlign: "center",
                    fontSize: "0.85rem",
                  }}
                >
                  {formatearNumero(item.precioFinalDinero)} MINI-HUESO
                </Typography>
              )}

              {puedeSaldoToken && (
                <Typography
                  sx={{
                    color: "#e040fb",
                    fontWeight: "bold",
                    textShadow: "0 0 8px #e040fb",
                    textAlign: "center",
                    fontSize: "0.78rem",
                  }}
                >
                  {formatearNumero(precioExterno)} {getTextoSaldoToken(item)}
                </Typography>
              )}

              {Number(item.recargoAplicado || 0) > 0 && puedeDinero && (
                <Typography
                  sx={{
                    color: "#ffb74d",
                    textAlign: "center",
                    fontSize: "0.72rem",
                    mt: 0.5,
                  }}
                >
                  +{Math.round(Number(item.recargoAplicado) * 100)}% sin pack inicial
                </Typography>
              )}

              <Button
                disabled={disabledInitial}
                onClick={() => handleOpen(item)}
                sx={buttonStyle}
                variant="contained"
              >
                Buy
              </Button>
            </Box>
          );
        })
      )}

      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography
            sx={{
              textAlign: "center",
              color: "#fff",
              fontWeight: "bold",
              mb: 1,
              fontSize: "1.1rem",
            }}
          >
            {selectedItem ? getNombreVisible(selectedItem) : "Buy item"}
          </Typography>

          {selectedItem?.slug === "inicial" && informacion?.packInicial && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              You already have the initial pack.
            </Alert>
          )}

          <Typography
            sx={{
              textAlign: "center",
              color: "#ccc",
              mb: 2,
            }}
          >
            Choose the amount to buy
          </Typography>

          <TextField
            onChange={(e) => setInput(e.target.value)}
            value={input}
            fullWidth
            type="number"
            disabled={selectedItem?.slug === "inicial"}
            inputProps={{
              min: 1,
              max: 100,
            }}
            sx={{
              mb: 2,
              input: { color: "#fff" },
              label: { color: "#fff" },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "rgba(255,255,255,0.4)",
                },
                "&:hover fieldset": {
                  borderColor: "#fff",
                },
              },
            }}
          />

          {selectedItem && precioExternoSeleccionado > 0 && (
            <Typography
              sx={{
                color: "#FFD700",
                textAlign: "center",
                fontWeight: "bold",
                mb: 1,
              }}
            >
              {getTextoPagoExterno(selectedItem)}:{" "}
              {formatearNumero(totalExterno)} {selectedItem.monedaExterna}
            </Typography>
          )}

          {selectedItem && puedeComprarConDineroJuego(selectedItem) && (
            <>
              <Typography
                sx={{
                  color: "#00e5ff",
                  textAlign: "center",
                  fontWeight: "bold",
                  mb: 0.5,
                }}
              >
                Game money: {formatearNumero(totalDineroSeleccionado)} MINI-HUESO
              </Typography>

              <Typography
                sx={{
                  color: tieneSaldoDinero() ? "#9be7ff" : "#ff7676",
                  textAlign: "center",
                  fontSize: "0.82rem",
                  mb: 1,
                }}
              >
                Disponible: {formatearNumero(saldos.dinero)} MINI-HUESO
              </Typography>
            </>
          )}

          {selectedItem && puedeComprarConSaldoToken(selectedItem) && (
            <>
              <Typography
                sx={{
                  color: "#e040fb",
                  textAlign: "center",
                  fontWeight: "bold",
                  mb: 0.5,
                }}
              >
                {getTextoSaldoToken(selectedItem)}:{" "}
                {formatearNumero(totalSaldoTokenSeleccionado)}{" "}
                {selectedItem.monedaExterna}
              </Typography>

              <Typography
                sx={{
                  color: tieneSaldoToken() ? "#f3a6ff" : "#ff7676",
                  textAlign: "center",
                  fontSize: "0.82rem",
                  mb: 2,
                }}
              >
                Disponible:{" "}
                {formatearNumero(saldos[getCampoSaldoToken(selectedItem)] || 0)}{" "}
                {selectedItem.monedaExterna}
              </Typography>
            </>
          )}

          <Button
            onClick={handleBuyWithKeychain}
            fullWidth
            disabled={
              buying ||
              !selectedItem ||
              (selectedItem?.slug === "inicial" && informacion?.packInicial)
            }
            sx={buttonStyle}
          >
            {buying ? "Processing..." : getTextoBotonExterno(selectedItem)}
          </Button>

          {selectedItem && puedeComprarConDineroJuego(selectedItem) && (
            <Button
              onClick={handleBuyWithDinero}
              fullWidth
              disabled={buying || !tieneSaldoDinero()}
              sx={secondaryButtonStyle}
            >
              {buying
                ? "Processing..."
                : tieneSaldoDinero()
                ? "BUY WITH MINI-HUESO"
                : "SALDO MINI-HUESO INSUFICIENTE"}
            </Button>
          )}

          {selectedItem && puedeComprarConSaldoToken(selectedItem) && (
            <Button
              onClick={handleBuyWithSaldoToken}
              fullWidth
              disabled={buying || !tieneSaldoToken()}
              sx={balanceButtonStyle}
            >
              {buying
                ? "Processing..."
                : !tieneSaldoToken()
                ? "INSUFFICIENT BALANCE"
                : selectedItem.monedaExterna === "HUESO"
                ? "BUY WITH IN-GAME HUESO"
                : "BUY WITH IN-GAME VIPHUESO"}
            </Button>
          )}
        </Box>
      </Modal>

      <Snackbar
        open={snack.open}
        autoHideDuration={5000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snack.type}
          onClose={() => setSnack({ ...snack, open: false })}
          sx={{ width: "100%" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
};
